import { Injectable } from '@angular/core';

declare var gtag;
@Injectable({
  providedIn: 'root'
})
export class TagManagerService {

  private _window: Window = window;
  private dataLayer = this._window['dataLayer'] = this._window['dataLayer'] || [];

  constructor () {}

  sendEvent(event: string) {
    this.dataLayer.push({
        event,
        data: {
            name: 'yerson'
        }
    });
  }

}
